module.exports = __webpack_public_path__ + "static/img/1681_phase_function_Paper_PointsHejduk_Prediction.55440ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1681_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dolt
// module chunks = 0